import { GetDiscoverResult } from "results/discover/GetDiscoverResult";
import { GetDiscoverSetResult } from "results/discover/GetDiscoverSetResult";
import { GetDiscoverCategoryResult } from "results/discover/GetDiscoverCategoryResult";
import { GetDiscoverPromptResult } from "results/discover/GetDiscoverPromptResult";
import { GetDiscoverPublisherResult } from "results/discover/GetDiscoverPublisherResult";
import { GetDiscoverSearchResult } from "results/discover/GetDiscoverSearchResult";
import { FindPromptResult } from "results/discover/FindPromptResult";
import { FindSetResult } from "results/discover/FindSetResult";
import { useApiService } from "services/ApiService";

export const DiscoverApiService = () => {
    const { get } = useApiService({ controller: "/discover" });

    // get the user's current language
    const { language } = new Intl.Locale(navigator.language);

    return {
        getDiscover: (country: string) => get<GetDiscoverResult>(`/?country=${country}&language=${language}`),
        getSet: (id: number) => get<GetDiscoverSetResult>(`/set/${id}/${language}`),
        getCategory: (id: number) => get<GetDiscoverCategoryResult>(`/category/${id}/${language}`),
        getPrompt: (id: number, country: string) => get<GetDiscoverPromptResult>(`/prompt/${id}/${country}`),
        getPublisher: (name: string) =>
            get<GetDiscoverPublisherResult>(`/publisher/${language}?name=${encodeURIComponent(name)}`),
        findPrompt: (setName: string, promptName: string) =>
            get<FindPromptResult>(
                `/find-prompt?setName=${encodeURIComponent(setName)}&promptName=${encodeURIComponent(promptName)}`,
            ),
        findSet: (setName: string) => get<FindSetResult>(`/find-set?setName=${encodeURIComponent(setName)}`),
        search: (
            query?: string,
            schoolLevelId?: number,
            programId?: number,
            searchLanguage?: string,
            hasResources?: boolean,
        ) => {
            const params = new URLSearchParams();

            if (query) {
                params.append("query", query);
            }

            if (schoolLevelId) {
                params.append("schoolLevelId", schoolLevelId.toString());
            }

            if (programId) {
                params.append("programId", programId.toString());
            }

            if (searchLanguage) {
                params.append("language", searchLanguage);
            }

            if (hasResources) {
                params.append("hasResources", "true");
            }

            return get<GetDiscoverSearchResult>(`/search?${params.toString()}`);
        },
    };
};
